import {createSlice, PayloadAction} from '@reduxjs/toolkit'

import {BookingCreationResponse} from '@vio/core/src/booking/types/BookingCreationResponse'

import {BookStateType, initialState} from './reducer'

const setCurrentModuleState = (
  state: BookStateType,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  action: PayloadAction<string | Record<string, any>>
) => {
  state.offerBookState = action.type
}

const {actions, reducer} = createSlice({
  name: 'book',
  initialState,
  reducers: {
    bookOfferCreationError: setCurrentModuleState,
    bookOfferCreationConfirm: (
      state: BookStateType,
      action: PayloadAction<
        Partial<BookingCreationResponse> & {
          isWithThreeDomainSecure?: boolean
        }
      >
    ) => {
      state.offerBookState = action.type
    }
  }
})

export const {bookOfferCreationError, bookOfferCreationConfirm} = actions

export default reducer
